import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { useGetRedirectToTargetPageAfterRegistration } from '../../useGetRedirectToTargetPageAfterLogin'
import { LoginRegistrationRegistrationForm } from '../LoginRegistrationRegistrationForm/LoginRegistrationRegistrationForm'

interface RegistrationModelInterface {
  handleClose: () => void
  isOpen: boolean
}

export const LoginRegistrationRegistrationModal: FC<
  RegistrationModelInterface
> = ({ handleClose, isOpen }) => {
  const redirectToTargetPage = useGetRedirectToTargetPageAfterRegistration()

  return (
    <Dialog
      onClose={handleClose}
      open={isOpen}
      slotProps={{
        dialog: {
          className: 'tablet:max-h-[90vh] tablet:max-w-[630px]',
        },
      }}
    >
      <DialogTitle className="bg-light-primary-low" onClose={handleClose}>
        <FormattedMessage id="registration.createAccount.headline" />
      </DialogTitle>
      <DialogContent>
        <LoginRegistrationRegistrationForm
          afterLoggedIn={redirectToTargetPage}
          handleClose={handleClose}
        />
      </DialogContent>
    </Dialog>
  )
}
